export const mapboxToken =
  "pk.eyJ1IjoibWluaHRhbjg4bSIsImEiOiJjbHBzNzI3OGMwMHR5Mmpyenh2emdjd3RwIn0.XtY7F_YpVsHqXQzIylqsiw";

export const boundaryColor = [
  "#8b5cf6",
  "#eab308",
  "#0ea5e9",
  "#10b981",
  "#06b6d4",
  "#84cc16",
  "#22c55e",
  "#14b8a6",
  "#f59e0b",
  "#f43f5e",
  "#a855f7",
  "#d946ef",
  "#ef4444",
  "#f97316",
  "#ec4899",
  "#6366f1",
  "#3b82f6",
];

const customIconUrl_1 = `${window.location.origin}/wp-content/themes/iphub/img/pin.png`;
export const customIcon_1 = L.icon({
  iconUrl: customIconUrl_1,
  iconSize: [30, 38],
  iconAnchor: [10, 19],
  className: "iphub-marker iphub-marker-1",
});

const customIconUrl_2 = `${window.location.origin}/wp-content/themes/iphub/img/pin-2.png`;
export const customIcon_2 = L.icon({
  iconUrl: customIconUrl_2,
  iconSize: [30, 38],
  iconAnchor: [10, 19],
  className: "iphub-marker iphub-marker-2",
});
